window.RS = window.RS || {};

window.FreeGift = (function () {
  const OPEN = "open";
  const ADDED = "added";
  const DATA_ACTIVE = "data-active";
  const PROP_FREE_GIFT = "_GWP";
  const IN_COLLECTION = "_in_collection"
  const LO_FREE_GIFT_KEY = "_free-gift-modal";
  const GIFT_BAR_EL = "free-gift-bar";
  const CART_CTA_EL = `.free-gift__cta`;
  const FREE_GIFT_EL = ".free-gift__product";
  // Event dispatched from  js/custom-element/section/cart/free-gift-bar.js
  const CTA_CLICKED = "free-gift-bar:cta-clicked";
  const CART_UPDATED = "cart:updated";
  const MODAL_EL = '[data-module="free-gift"]';
  const MODAL_CTA_EL = '[data-action="add-to-cart"]';
  let giftBarEl,
    cartCtaEl,
    modalEl,
    threshold,
    giftEls,
    giftBarDeaultText,
    giftBarChangeText;

  async function debounceUpdateModalCta() {
    await debounce(updateModalCta, 500);
  }

  function initEvents() {
    document.addEventListener(CTA_CLICKED, async function (e) {
      await updateModalCta();
      openModal();
    });

    document.addEventListener(CART_UPDATED, async function (e) {
      if (!e?.detail) {
        return;
      }
      const { cart } = e.detail;
      const cartTotal = calculateCartTotal(cart);
      if (cartTotal >= threshold) {
        await updateModalCta();
        if (checkLocalStorage()) {
          openModal();
        }
      } else {
        const active = modalEl?.dataset?.active;
        if (active) {
          await onRemoveFromCart(active);
          const cartObject = await getCart();
          debounceUpdateModalCta(cartObject);
        }
      }
    });
    if (modalEl) {
      modalEl.addEventListener("click", function (e) {
        const target = e.target;
        if (target.matches(MODAL_CTA_EL)) {
          onAddToCart(target);
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        } else {
          closeModal();
        }
      });
    }
  }

  function checkLocalStorage() {
    let bool = false;
    if (!localStorage.getItem(LO_FREE_GIFT_KEY)) {
      const currentTime = timeStamp();
      localStorage.setItem(LO_FREE_GIFT_KEY, currentTime);
      bool = true;
    }
    return bool;
  }

  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  function timeStamp() {
    return new Date().getTime();
  }

  function calculateCartTotal(cart) {
    return cart?.items.reduce((total, item) => {
      if (item.properties[IN_COLLECTION] == 'true') {
        return total + item.discounted_price * item.quantity;
      } 
      else {
        return total
      }
    }, 0);
  }

  async function updateModalCta(carObject = null) {
    let cart;
    if (carObject) {
      cart = carObject;
    } else {
      cart = await getCart();
    }
    if (cart?.items?.length > 0) {
      const { ctaDefault, ctaAdded, ctaSwap, count } = modalEl?.dataset;
      cartCtaEl = document.querySelector(CART_CTA_EL);
      for (const item of cart.items) {
        const { id, properties } = item;
        if (properties && properties[PROP_FREE_GIFT]) {
          if (giftEls?.length > 0 && modalEl) {
            giftEls.forEach((giftEl) => {
              const ctaEl = giftEl.querySelector(MODAL_CTA_EL);
              if (!ctaEl) return;
              if (id?.toString() === giftEl.dataset.variantId) {
                ctaEl.textContent = ctaAdded;
                ctaEl.classList.add(ADDED);
                modalEl.dataset.active = id;
                let copy;
                if (count && count === "1") {
                  copy = giftBarDeaultText;
                } else {
                  copy = giftBarChangeText;
                }
                if (cartCtaEl) {
                  cartCtaEl.textContent = copy;
                }
              } else {
                ctaEl.textContent = ctaSwap;
                ctaEl.classList.remove(ADDED);
              }
            });
          }
          break;
        } else {
          if (giftEls?.length > 0 && modalEl) {
            giftEls.forEach((giftEl) => {
              const ctaEl = giftEl.querySelector(MODAL_CTA_EL);
              if (!ctaEl) return;
              ctaEl.textContent = ctaDefault;
              ctaEl.classList.remove(ADDED);
              if (cartCtaEl) {
                cartCtaEl.textContent = giftBarDeaultText;
              }
            });
          }
        }
      }
    }
  }

  async function onRemoveFromCart(active) {
    const payload = {
      updates: {
        [active]: 0,
      },
    };
    const result = await removeFromCart(payload);
    if (result?.error) {
      console.error(result.error);
    } else {
      const giftItemEl = document.querySelector(
        `cart-drawer [data-slidecart-item="${active}"][data-free-gift="true"]`
      );
      if (giftItemEl) {
        const cartContent = await removeFromCart({
          updates: {
            [giftItemEl.getAttribute('data-key')]: 0,
          },
        });
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
          bubbles: true,
          detail: {
            cart: cartContent?.cart
          }
        }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: cartContent?.cart
          }
        }));
      }
      modalEl.removeAttribute(DATA_ACTIVE);
    }
  }

  async function onAddToCart(target) {
    const active = modalEl.dataset.active;
    if (active) {
      await onRemoveFromCart(active);
    }
    const parentEl = target?.closest(FREE_GIFT_EL);
    const id = parentEl?.dataset?.variantId;
    const payload = {
      items: [
        {
          id,
          quantity: 1,
          properties: {
            [PROP_FREE_GIFT]: 'true',
            [IN_COLLECTION]: 'false'
          },
        },
      ],
    };
    const result = await addToCart(payload);
    if (result?.error) {
      console.error(result.error);
    } else {
      modalEl.dataset.active = id;
      updateModalCta();
    }
  }

  async function getCart() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      if (response.ok) {
        const cart = await response.json();
        return cart;
      }
    } catch (error) {
      return { error: error.message };
    }
  }

  async function removeFromCart(payload) {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/update.js`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      if (response.ok) {
        const cart = await response.json();
        return { cart };
      }
    } catch (error) {
      return { error: error.message };
    }
  }

  async function addToCart(payload) {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      // if (response.ok) {
      //   const cart = await response.json();
        
      //   return { cart };
      // }
      if (response.ok) {
        const responseJson = await response.json();
        const cartResp = await fetch(`${window.themeVariables.routes.cartUrl}.js`).catch(e => {
          console.log(e)
        });
        const cartContent = cartResp ? await cartResp.json() : {};
        const drawer = document.querySelector(".drawer");

        const variantAdded = responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson;
        this.dispatchEvent(new CustomEvent("variant:added", {
          bubbles: true,
          detail: {
            variant: variantAdded,
            cart: cartContent
          }
        }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
          bubbles: true,
          detail: {
            cart: cartContent,
            variant: variantAdded
          }
        }));
        cartContent["sections"] = responseJson["sections"];
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: cartContent,
            openMiniCart: window.themeVariables.settings.cartType === "drawer" && !drawer?.hasAttribute("open"),
            variant: variantAdded
          }
        }));
      }
    } catch (error) {
      return { error: error.message };
    }
  }

  function closeModal() {
    if (modalEl && modalEl.classList.contains(OPEN)) {
      modalEl.classList.remove(OPEN);
    }
  }

  function openModal() {
    if (modalEl && !modalEl.classList.contains(OPEN)) {
      modalEl.classList.add(OPEN);
    }
  }

  function initialize() {
    giftBarEl = document.querySelector(GIFT_BAR_EL);
    modalEl = document.querySelector(MODAL_EL);
    if (giftBarEl) {
      const attr = giftBarEl.getAttribute("threshold");
      threshold = attr ? parseFloat(attr) : 0;
      giftBarDeaultText = giftBarEl.dataset.ctaDefault;
      giftBarChangeText = giftBarEl.dataset.ctaChange;
    }
    giftEls = document.querySelectorAll(FREE_GIFT_EL);
    initEvents();
    updateModalCta();
  }

  return {
    initialize: initialize,
  };
})();

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    window.FreeGift.initialize();
  });
})();
